/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, SortableList, FormControl, ModalFooter } from 'modules/theme';
import { colors } from 'modules/common/styles';
var uuid = require('uuid');

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${colors.bgActive};
  border: 1px solid ${colors.borderPrimary};
  border-radius: 2px;
  margin-bottom: 5px;

  > span {
    text-transform: uppercase;
    padding: 5px 20px 5px 40px;
    font-weight: bold;
  }
`;

const Footer = styled.div`
  text-align: right;
  margin-top: 20px;
`;

const Child = styled.div`
  width: 100%;
  label {
    float: right;
  }
`;

const contextTypes = {
  closeModal: PropTypes.func.isRequired,
  __: PropTypes.func
};

class ManageColumns extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeFields = this.onChangeFields.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);

    props.config.sort(function (a, b) {
      return a.order - b.order;
    });
    console.log('props.fields', props.fields);
    var field = props.fields;
    let t = 10000;
    for (let f of field) {
      f = t;
      t--;
      for (let c of props.config) {
        if (f === c) {
          f = c;
          // f.tag = c.order;
        }
      }
    }

    field.sort(function (a, b) {
      return a.tag - b.tag;
    });

    this.state = {
      fields: field
    };
  }

  onSubmit(e) {
    console.log('Hiiii');
    e.preventDefault();

    const columnsConfig = [];

    console.log('fielsaSubmit',this.state.fields);

    this.state.fields.forEach((field, index) => {
      const element = document.getElementById(field._id);

      if (element.checked) {
        columnsConfig.push({
          order: index,
          name: field.name,
          ...field
        });
      }
    });

    this.props.save(columnsConfig);
  }

  onFieldChange(e, fieldId) {
    // console.log('Hiiiii', e.target.value, fieldId, "fields", this.state.fields);
    let val = e.target.value;
    var fields = this.state.fields;
    for (var field of fields) {
      if (field._id === fieldId) {
        field.label = val;
        console.log("field.label", field.label);
      }
    }
    this.setState({ fields });
    console.log("fields", fields);
  }
  onFieldCheckedChange(fieldId, value) {
    console.log('fieldId,value', fieldId, value);
    var fields = this.state.fields;
    for (var field of fields) {
      if (field._id === fieldId) {
        console.log('field._id,fieldId', field,fieldId);
        field.checked = value;
      }
    }
    this.setState({ fields });
  }

  onChangeFields(fields) {
    console.log("fields", fields);
    this.setState({ fields });
  }

  render() {
    const { config } = this.props;
    const { __ } = this.context;
    const { modalType } = this.props;

    const configMap = {};
    const configLable = {};
    let _this = this;

    config.forEach(config => {
      configMap[config] = true;
    });

    // config.forEach(config => {
    //   configLable[config.label] = config.label;
    // });

    const child = field => {
      // console.log('ffff', field);

      let name =  field.label|| field.name;
      return (
        <Child>
          <span>{name}</span>
          <FormControl
            id={field._id}
            defaultChecked={configMap[field.name]}
            componentClass="checkbox"
            onChange={(e) => {
              _this.onFieldCheckedChange(field._id, e.target.checked)
            }}
          />
          <FormControl
            id={String(uuid.v4())}
            type="input"
            placeholder={name}
            onChange={e => this.onFieldChange(e, field._id)}
          />
        </Child>
      );
    };

    return (
      <form onSubmit={this.onSubmit}>
        <Header>
          <span>{__('Column field')}</span>
          <span>{__('Visible')}</span>
          <span>{__('Column name')}</span>
        </Header>

        <SortableList
          fields={this.state.fields}
          child={child}
          onChangeFields={this.onChangeFields}
          isModal={true}
        />

        <ModalFooter modalType={modalType}>
          <Button
            btnStyle="cancel"
            onClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            Submit
          </Button>
        </ModalFooter>


        {/* <Footer>
          <Button
            type="button"
            btnStyle="simple"
            onClick={closeModal}
            icon="cancel-1"
          >
            Cancel
          </Button>

          <Button
            type="submit"
            onClick={closeModal}
            btnStyle="default"
            icon="checked-1"
          >
            Submit
          </Button>
        </Footer> */}
      </form>
    );
  }
}

ManageColumns.propTypes = {
  fields: PropTypes.array.isRequired,
  config: PropTypes.array,
  save: PropTypes.func.isRequired
};

ManageColumns.contextTypes = contextTypes;

export default ManageColumns;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ManageColumns.js